export class SurveyAnswer {
    public id: number;
    public questionNum: number;
    public questionText: string;
    public optionText: string;
    public optionValue: number;
    public questionType: string;
}


// WEBPACK FOOTER //
// ./src/models/SurveyAnswer.tsx